var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 5",
    d: "M0 0h20v20H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 6",
    d: "M16.667 3.333H3.334A1.664 1.664 0 001.675 5l-.008 10a1.672 1.672 0 001.667 1.667h13.333A1.672 1.672 0 0018.334 15V5a1.672 1.672 0 00-1.667-1.667zm0 11.667H3.334V6.666L10 10.833l6.667-4.167zM10 9.166L3.334 5h13.333z",
    fill: "#666"
  })));
}

export default SvgMailIcon;